import { useEffect, useState, useContext } from "react";
import logo from "../../assets/Home/main-log.svg";
import "./Header.scss";
import { IoIosArrowForward } from "react-icons/io";
import { GoPlus, GoDash } from "react-icons/go";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { AppContext } from "../../context/AppContext";
import axios from "axios";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openSections, setOpenSections] = useState(false);
  const location = useLocation();
  const ishomeActive = location.pathname.startsWith("/home");
  const isAboutActive = location.pathname.startsWith("/aboutus");
  const isAdministration = location.pathname.startsWith("/administration")
  const isAcademicsActive = location.pathname.startsWith("/academics");
  const isCampusActive = location.pathname.startsWith("/Campus_Life");
  const isIqacActive = location.pathname.startsWith("/iqac");
  const isAdmissionActive = location.pathname.startsWith("/Admission");
  const isAluminiActive = location.pathname.startsWith("/alumini");
  const isHelpdeskActive = location.pathname.startsWith("/Helpdesk");
  const [activeIndex, setActiveIndex] = useState(null);
  const { backendUrl } = useContext(AppContext);
  const [isShowdropdown, setisShowdropdown] = useState(true);
  const [allAnnouncements, setAllAnnouncements] = useState([]);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleSection = (section) => {
    setOpenSections((prev) => {
      const newState = {};
      newState[section] = !prev[section];
      return newState;
    });
  }

  const handleLinkClick = (path, sectionToClose) => {
    setIsMobileMenuOpen(false);
    setActiveIndex(null);
    navigate(path);
    setOpenSections((prev) => ({ ...prev, [sectionToClose]: false }));
  };

  const useHideHeaderIcons = () => {
    useEffect(() => {
      const hideSVGs = () => {
        const headers = document.querySelectorAll(
          "[id$='_header_0']"
        );
        headers.forEach((header) => {
          const svg = header.querySelector("svg");
          if (svg) {
            svg.style.display = "none";
          }
        });
      };
      hideSVGs();

      const observer = new MutationObserver(hideSVGs);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return () => observer.disconnect();
    }, []);
  };

  useHideHeaderIcons();

  async function fetchAnnouncements() {
    try {
      const { data } = await axios.get(`${backendUrl}/api/auth/getAllAnnouncements`);
      if (data.success)
        setAllAnnouncements(data.announcements);
    } catch (error) {
      console.error("No internet Connection");
    }
  }

  useEffect(() => {
    fetchAnnouncements();
  }, [])

  return (
    <header className="header-nav">
      <nav>
        <div className="logo-with-anouncement">
          <div className="logo">
            <div className="logo-img">
              <img className="left-logo-img" src={logo} alt="" />
            </div>
          </div>

          <div className="anouncement">
            <div className="anouncement-marquee-box">
              <marquee
                key={allAnnouncements.length}
                onMouseOver={(event) => event.currentTarget.stop()}
                onMouseLeave={(event) => event.currentTarget.start()}
                className="running-content"
                behavior="smooth"
                direction="left"
                scrollamount="6"
              >
                <span style={{ display: "inline-flex" }}>
                  {allAnnouncements.filter((announcement) => announcement.isActive)
                    .filter((announcement) => announcement.recent)
                    .map((announcement, index, arr) => (
                      <p key={announcement.id}>
                        {announcement.announcement}<span style={{ margin: "20px" }}>
                          {arr.length > 1 && index !== arr.length - 1 ? "||" : ""}</span>
                      </p>
                    ))}
                </span>
              </marquee>
            </div>
          </div>
        </div>
        <div className={`nav-bar`}>
          <div className="nav-list-items">
            <ul className="main-menu-items">
              <li onClick={() => navigate("/")} className="home">
                <a href="#" className={ishomeActive ? "active" : ""}> HOME</a>
              </li>
              <li className="about">
                <a href="#" className={isAboutActive ? "active" : ""} onMouseOver={() => setisShowdropdown(true)}>ABOUT US</a>
                <div className={isShowdropdown === true ? "about-us" : "about-display"}  >
                  <ul>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/aboutus/profile"); }} >Profile of the College</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/aboutus/vision-mission"); }} >Vision & Mission</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/aboutus/history"); }} >History of Nicas</li>
                    <li className="ip-menu"> Institutional Partner <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="ip-sub-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/aboutus/ICT_Academy"); }}> ICT Academy </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/aboutus/MOU"); }} > MOU </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="administration">
                <a href="#" className={isAdministration ? "active" : ""} onMouseOver={() => setisShowdropdown(true)}> ADMINISTRATION </a>
                <div className={isShowdropdown === true ? "administration-menu" : "administration-display"}>
                  <ul>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/administration/president") }} >President</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/administration/secretary"); }} >Secretary</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/administration/principal"); }} >Principal</li>
                    <li className="sb-menu">Statutory Bodies <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="statutory-bodies-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/administration/statutory-bodies/governing-bodies"); }} > Governing Bodies</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/administration/statutory-bodies/academic-council"); }} >Academic Council</li>
                        </ul>
                      </div>
                    </li>
                    <li className="nsb-menu">Non Statutory Bodies<IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="nsb-sub-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/administration/non-statutory-bodies/examination-committee"); }} > Examination Committee</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/administration/non-statutory-bodies/parent-teacher-association"); }} >Parent Teacher Association</li>
                        </ul>
                      </div>
                    </li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/administration/ombudsman"); }}>Ombudsman</li>
                  </ul>
                </div>
              </li>
              <li className="academies">
                <a href="#" className={isAcademicsActive ? "active" : ""} onMouseOver={() => setisShowdropdown(true)}>ACADEMICS</a>
                <div className={isShowdropdown === true ? "academies-menu" : "academic-display"}>
                  <ul>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/academics/ug-programmes"); }} >UG Programmes</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/academics/pg-programmes"); }} >PG Programmes</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/academics/research"); }} >Research</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/academics/academic-calendar"); }} >Academic Calendar</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/academics/curriculum-and-syllabus"); }} >Curriculum & Syllabus</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/academics/study-materials"); }} >Study Materials</li>
                  </ul>
                </div>
              </li>
              <li className="campus">
                <a href="#" className={isCampusActive ? "active" : ""} onMouseOver={() => setisShowdropdown(true)}>CAMPUS LIFE</a>
                <div className={isShowdropdown === true ? "campus-menu" : "campuslife-display"}>
                  <ul>
                    <li className="ea">Extension Activities<IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="ea-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Extension_Activities/NSS"); }} >NSS</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Extension_Activities/NCC"); }} >NCC</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Extension_Activities/YRC"); }} >YRC</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Extension_Activities/RRC"); }}  >RRC</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Extension_Activities/Sports"); }} >Sports</li>
                        </ul>
                      </div>
                    </li>
                    <li className="ptcg"> Placement Training & Career Guidance <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="ptcg-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Placement_and_Career/Inhouse_Training"); }} >Inhouse Training </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Placement_and_Career/Outsource_Training"); }} >Outsource Training</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Placement_and_Career/TNPSC_-_Competitive_Exam_Coaching"); }} >TNPSC - Competitive Exam Coaching</li>
                        </ul>
                      </div>
                    </li>
                    <li className="ss"> Student Support <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="ss-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Student_Support/Student_Council"); }} >Student Council</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Student_Support/Mentor_Mentee"); }} >Mentor Mentee</li>
                        </ul>
                      </div>
                    </li>
                    <li className="schol" onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Scholarship"); }} >Scholarship</li>
                    <li className="clubs"> Clubs <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="clubs-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Club/Save_Green_Club"); }} >Save Green Club</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Club/Citizen_Consumer_Club"); }} >Citizen Consumer Club </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Club/Cultural_Club"); }} > Cultural Club </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Club/Electrol_Club"); }} >Electrol Club</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Club/Quiz_Club"); }} >Quiz Club</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Club/Rotaract_Club"); }} > Rotaract Club</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Club/Legal_AID_Club"); }} >Legal Aid Club</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Club/Reader_Club"); }} >Reader's Club</li>
                        </ul>
                      </div>
                    </li>
                    <li className="se">Skill Enhancement<IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="se-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Skill_Enhancement/Enterpreneurship_Development_Cell"); }} > Entreprenuership Development Cell</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Skill_Enhancement/Institution_Innovation_Council"); }} > Institution Innovation Council</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Skill_Enhancement/TNSTC_-_Naan_Mudhalva"); }} > TNSDC/Naan Mudhalvan</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Skill_Enhancement/SWAYAM_-_NPTEL_-_MOOC"); }} >Swayam/NPTEL/Mooc</li>
                        </ul>
                      </div>
                    </li>
                    <li className="infra">Infrastructure <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="infra-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Infrastructure/Laboratory_Facility"); }} > Laboratory Facility </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Infrastructure/Library"); }} >Library</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Infrastructure/Hostel"); }} >Hostel</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Infrastructure/Transportation"); }} >Transportation </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Infrastructure/Play_Ground"); }} >Playground </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Infrastructure/Canteen"); }} >Canteen </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Infrastructure/Auditorium"); }} >Auditorium</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Infrastructure/Green_Campus"); }} >Green Campus</li>
                        </ul>
                      </div>
                    </li>
                    <li className="gr">Grievance Redressal <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="gr-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Grievance_Redressal/Women_Cell"); }} >Women’s Cell</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Grievance_Redressal/Anti_Ragging_-_Eve_teasing"); }} >Anti Ragging / Eve teasing  </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Grievance_Redressal/Anti_Drug_Awareness"); }} >Anti Drug Awareness</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Grievance_Redressal/Cyber_Crime_Awareness"); }} > Cyber Crime Awareness  </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Grievance_Redressal/Internal_Compliance_Committee"); }} >Internal Compliants Committee   </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Campus_Life/Grievance_Redressal/Ombudsman"); }} >Ombudsman </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="iqac">
                <a href="#" className={isIqacActive ? "active" : ""} onMouseOver={() => setisShowdropdown(true)}>IQAC</a>
                <div className={isShowdropdown === true ? "iqac-menu" : "iqac-display"}>
                  <ul>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/about"); }} >About IQAC</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/best-practices"); }} >Best Practices</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/distinctiveness"); }} >Distinctiveness </li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/academic-audit-report"); }} >Academic Audit Report Template</li>
                    <li className="committees"> Committees <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="committees-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/committees/staff-council"); }} >Staff Council</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/committees/staff-association"); }} >Staff Association</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/committees/discipline-committee"); }} >Discipline Committee</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/committees/website-maintenance"); }} >  Website Maintainance   </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/committees/college-council"); }} >College Council  </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/committees/sports-advisory"); }} > Sports Advisory</li>
                        </ul>
                      </div>
                    </li>
                    <li className="naac">NAAC <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="naac-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/naac/assessment-criteria"); }} > Criteria </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/naac/minutes"); }} >Minutes</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/naac/aqars"); }} >AQARS </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/naac/calendar-handbook"); }} >Calendar Handbook</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/naac/outcomes"); }} >Outcomes</li>
                        </ul>
                      </div>
                    </li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/nirf"); }} > NIRF</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/aishe"); }} > AISHE</li>
                    <li className="feedback">Feedback <IoIosArrowForward className="dropdownArrow" size={20} />
                      <div className="feedback-menu">
                        <ul>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/feedback/sss"); }} >SSS</li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/feedback/student-feedback"); }} >Student’s Feedback </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/feedback/teacher-feedback"); }} >Staff's Feedback </li>
                          <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/iqac/feedback/employee-feedback"); }} >Parent's Feedback</li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="admission">
                <a href="#" className={isAdmissionActive ? "active" : ""} onMouseOver={() => setisShowdropdown(true)}>ADMISSION</a>
                <div className={isShowdropdown === true ? "admission-menu" : "admission-display"}>
                  <ul>
                    <li onClick={() => { window.open("/Admission/Prospectus.pdf", "_blank"); setisShowdropdown(!isShowdropdown); const handleFocus = () => { navigate("/Admission/Admission_Committee"); window.removeEventListener("focus", handleFocus); }; window.addEventListener("focus", handleFocus); }}> Prospectus</li>
                    <li onClick={() => { window.open("/Admission/BrochureNICAS.pdf", "_blank"); setisShowdropdown(!isShowdropdown); const handleFocus = () => { navigate("/Admission/Admission_Committee"); window.removeEventListener("focus", handleFocus); }; window.addEventListener("focus", handleFocus); }}>Brochure</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Admission/Admission_Committee"); }} >Admission Committee </li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Admission/Application_For_Admission"); }}>Application For Admission </li>
                  </ul>
                </div>
              </li>
              <li className="alumni">
                <a href="#" className={isAluminiActive ? "active" : ""} onMouseOver={() => setisShowdropdown(true)}>ALUMINI</a>
                <div className={isShowdropdown === true ? "alumni-menu" : "alumini-display"}>
                  <ul>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/alumini/objectives"); }} >Objectives</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/alumini/executive-committee"); }}>Executive Committee</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/alumini/news-letter"); }} >Newsletter</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/alumini/achievers-gallery"); }}>Achievers Gallery</li>
                  </ul>
                </div>
              </li>
              <li className="helpdesk">
                <a href="#" className={isHelpdeskActive ? "active" : ""} onMouseOver={() => setisShowdropdown(true)}> HELP DESK</a>
                <div className={isShowdropdown === true ? "helpdesk-menu" : "helpdesk-display"}>
                  <ul>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Helpdesk/Inquiry-Desk") }}>Inquiry Desk</li>
                    <li onClick={() => { setisShowdropdown(!isShowdropdown); navigate("/Helpdesk/Inquiry-Career") }}>Career Inquiry</li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="accordion-header">
          <div className="accordion-logo">
            <div className="logo-img">
              <img className="left-logo-img" src={logo} alt="" />
            </div>
            <div className="burger-menu" onClick={toggleMenu}><i className={isMobileMenuOpen ? "fa-solid fa-times" : "fa-solid fa-bars"}></i></div>
          </div>
          <div className="accordion-announcement">
            <marquee
              key={allAnnouncements.length}
              onMouseOver={(event) => event.currentTarget.stop()}
              onMouseLeave={(event) => event.currentTarget.start()}
              className="running-content"
              behavior="smooth"
              direction="left"
              scrollamount="6"
            >
              <span style={{ display: "inline-flex" }}>
                {allAnnouncements.filter((announcement) => announcement.isActive)
                  .filter((announcement) => announcement.recent)
                  .map((announcement, index, arr) => (
                    <p key={announcement.id}>
                      {announcement.announcement}<span style={{ margin: "20px" }}>
                        {arr.length > 1 && index !== arr.length - 1 ? "||" : ""}</span>
                    </p>
                  ))}
              </span>
            </marquee>
          </div>
        </div>
        <div className="container">
          <div className={`accordion-container  ${isMobileMenuOpen ? "open" : ""}`}>
            <div className="accordion-content">
              <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}
                expandIcon={<FaCaretDown />}
                collapseIcon={<FaCaretUp />} >
                <AccordionTab href="/" header="Home" onClick={() => { setIsMobileMenuOpen(false); navigate("/"); }}></AccordionTab>
                <AccordionTab header="About Us">
                  <ul className="acc-main-menu">
                    <li onClick={() => handleLinkClick("/aboutus/profile")}>Profile of the College</li>
                    <li onClick={() => handleLinkClick("/aboutus/vision-mission")}>Vision & Mission</li>
                    <li onClick={() => handleLinkClick("/aboutus/history")}>History of Nicas</li>
                    <li className="plus-symbol" onClick={() => toggleSection("institutionalpartner")}>Institutional Partner {openSections["institutionalpartner"] ? (<GoDash />) : (<GoPlus />)}</li>
                    {openSections["institutionalpartner"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/aboutus/ICT_Academy")}>ICT Academy</li>
                        <li onClick={() => handleLinkClick("/aboutus/MOU")}>MOU</li>
                      </ul>
                    )}
                  </ul>
                </AccordionTab>
                <AccordionTab header="Administration">
                  <ul className="acc-main-menu">
                    <li onClick={() => handleLinkClick("/administration/president")}>President</li>
                    <li onClick={() => handleLinkClick("/administration/secretary")}>Secretary</li>
                    <li onClick={() => handleLinkClick("/administration/principal")}>Principal</li>
                    <li className="plus-symbol" onClick={() => toggleSection("statutory")} >Statutory Bodies {openSections["statutory"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["statutory"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/administration/statutory-bodies/governing-bodies", "statutory")}>Governing Bodies</li>
                        <li onClick={() => handleLinkClick("/administration/statutory-bodies/academic-council", "statutory")}>Academic Council</li>
                      </ul>
                    )}
                    <li className="plus-symbol" onClick={() => toggleSection("nonstatutory")}>Non Statutory Bodies{openSections["nonstatutory"] ? (<GoDash />) : (<GoPlus />)}</li>
                    {openSections["nonstatutory"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/administration/non-statutory-bodies/examination-committee", "nonstatutory")}>Examination Committee</li>
                        <li onClick={() => handleLinkClick("/administration/non-statutory-bodies/parent-teacher-association", "nonstatutory")}>Parent Teacher Association</li>
                      </ul>
                    )}
                    <li onClick={() => handleLinkClick("/administration/ombudsman")}>Ombudsman</li>
                  </ul>

                </AccordionTab>
                <AccordionTab header="Academics">
                  <ul className="acc-main-menu">
                    <li onClick={() => handleLinkClick("/academics/ug-programmes")}>UG Programmes</li>
                    <li onClick={() => handleLinkClick("/academics/pg-programmes")}>PG Programmes</li>
                    <li onClick={() => handleLinkClick("/academics/research")}>Research</li>
                    <li onClick={() => handleLinkClick("/academics/academic-calendar")}>Academic Calendar</li>
                    <li onClick={() => handleLinkClick("/academics/curriculum-and-syllabus")}>Curriculum & Syllabus</li>
                    <li onClick={() => handleLinkClick("/academics/study-materials")} >Study Materials</li>
                    
                  </ul>
                </AccordionTab>
                <AccordionTab header="Campus Life">
                  <ul className="acc-main-menu">
                    <li className="plus-symbol" onClick={() => toggleSection("extension")}>Extension Activities{openSections["extension"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["extension"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/Campus_Life/Extension_Activities/NSS")}>NSS</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Extension_Activities/NCC")}>NCC</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Extension_Activities/YRC")}>YRC</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Extension_Activities/RRC")}>RRC</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Extension_Activities/Sports")}>Sports</li>
                      </ul>
                    )}
                    <li className="plus-symbol" onClick={() => toggleSection("ptcg")}> Placement Training & Career Guidance {openSections["ptcg"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["ptcg"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/Campus_Life/Placement_and_Career/Inhouse_Training")}>Inhouse Training</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Placement_and_Career/Outsource_Training")}>Outsource Training</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Placement_and_Career/TNPSC_-_Competitive_Exam_Coaching")}>TNPSC - Competitive Exam Coaching</li>
                      </ul>
                    )}
                    <li className="plus-symbol" onClick={() => toggleSection("ss")}>Student Support{openSections["ss"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["ss"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/Campus_Life/Student_Support/Student_Council")}>Student Council</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Student_Support/Mentor_Mentee")}>Mentor Mentee</li>
                      </ul>
                    )}
                    <li onClick={() => handleLinkClick("/Campus_Life/Scholarship")}>Scholarship</li>
                    <li className="plus-symbol" onClick={() => toggleSection("clubs")}> Club {openSections["clubs"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["clubs"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/Campus_Life/Club/Save_Green_Club")}>Save Green Club</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Club/Citizen_Consumer_Club")}>Citizen Consumer Club</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Club/Cultural_Club")}>Cultural Club</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Club/Electrol_Club")}>Electrol Club</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Club/Quiz_Club")}>Quiz Club</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Club/Rotaract_Club")}>Rotaract Club</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Club/Legal_AID_Club")}>Legal Aid Club</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Club/Reader_Club")}>Reader's Club</li>


                      </ul>
                    )}
                    <li className="plus-symbol" onClick={() => toggleSection("skill")}>Skill Enhancement {openSections["skill"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["skill"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/Campus_Life/Skill_Enhancement/Enterpreneurship_Development_Cell")}>Entreprenuership Development Cell</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Skill_Enhancement/Institution_Innovation_Council")}>Institution Innovation Council</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Skill_Enhancement/TNSTC_-_Naan_Mudhalva")}>TNSDC/Naan Mudhalvan</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Skill_Enhancement/SWAYAM_-_NPTEL_-_MOOC")}>Swayam/NPTEL/Mooc</li>
                      </ul>
                    )}
                    <li className="plus-symbol" onClick={() => toggleSection("infra")}> Infrastructure {openSections["infra"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["infra"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/Campus_Life/Infrastructure/Laboratory_Facility")}>Laboratory Facility</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Infrastructure/Library")}>Library</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Infrastructure/Hostel")}>Hostel</li>
                        <li onClick={() => handleLinkClick("/CampusLife/Infrastructure/Transportation")}>Transportation</li>
                        <li onClick={() => handleLinkClick("/CampusLife/Infrastructure/Play_Ground")}>Playground</li>
                        <li onClick={() => handleLinkClick("/CampusLife/Infrastructure/Canteen")}>Canteen</li>
                        <li onClick={() => handleLinkClick("/CampusLife/Infrastructure/Auditorium")}>Auditorium</li>
                        <li onClick={() => handleLinkClick("/CampusLife/Infrastructure/Green_Campus")}>Green Campus</li>
                      </ul>
                    )}

                    <li className="plus-symbol" onClick={() => toggleSection("gr")} >Grievance Redressal {openSections["gr"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["gr"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/Campus_Life/Grievance_Redressal/Women_Cell")}> Women’s Cell</li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Grievance_Redressal/Anti_Ragging_-_Eve_teasing")}> Anti Ragging / Eve teasing </li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Grievance_Redressal/Anti_Drug_Awareness")}> Anti Drug Awareness </li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Grievance_Redressal/Cyber_Crime_Awareness")}> Cyber Crime Awareness </li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Grievance_Redressal/Internal_Compliance_Committee")}> Internal Compliants Committee </li>
                        <li onClick={() => handleLinkClick("/Campus_Life/Grievance_Redressal/Ombudsman")}> Ombudsman  </li>
                      </ul>
                    )}
                  </ul>
                </AccordionTab>
                <AccordionTab header="IQAC">
                  <ul className="acc-main-menu">
                    <li onClick={() => handleLinkClick("/iqac/about")}> About IQAC</li>
                    <li onClick={() => handleLinkClick("/iqac/best-practices")}> Best Practices </li>
                    <li onClick={() => handleLinkClick("/iqac/distinctiveness")}> Distinctiveness </li>
                    <li onClick={() => handleLinkClick("/iqac/academic-audit-report")}> Academic Audit Report Template </li>
                    <li className="plus-symbol" onClick={() => toggleSection("commit")}>Committees {openSections["commit"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["commit"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/iqac/committees/staff-council", "commit")}>Staff Council</li>
                        <li onClick={() => handleLinkClick("/iqac/committees/staff-association", "commit")}>Staff Association</li>
                        <li onClick={() => handleLinkClick("/iqac/committees/discipline-committee", "commit")}>Discipline Committee</li>
                        <li onClick={() => handleLinkClick("/iqac/committees/website-maintenance", "commit")}> Website Maintainance </li>
                        <li onClick={() => handleLinkClick("/iqac/committees/college-council", "commit")}> College Council </li>
                        <li onClick={() => handleLinkClick("/iqac/committees/sports-advisory", "commit")}> Sports Advisory </li>
                      </ul>
                    )}

                    <li className="plus-symbol" onClick={() => toggleSection("naac")} > NAAC {openSections["naac"] ? <GoDash /> : <GoPlus />} </li>
                    {openSections["naac"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/iqac/naac/assessment-criteria", "naac")}> Criteria </li>
                        <li onClick={() => handleLinkClick("/iqac/naac/minutes", "naac")}> Minutes </li>
                        <li onClick={() => handleLinkClick("/iqac/naac/aqars", "naac")}> AQARS </li>
                        <li onClick={() => handleLinkClick("/iqac/naac/calendar-handbook", "naac")}> Calendar/Handbook </li>
                        <li onClick={() => handleLinkClick("/iqac/naac/outcomes", "naac")}> Outcomes </li>
                      </ul>
                    )}
                    <li onClick={() => handleLinkClick("/iqac/nirf")}>NIRF</li>
                    <li onClick={() => handleLinkClick("/iqac/aishe")}>AISHE</li>
                    <li className="plus-symbol" onClick={() => toggleSection("feedback")}>FeedBack {openSections["feedback"] ? <GoDash /> : <GoPlus />}</li>
                    {openSections["feedback"] && (
                      <ul className="accordion-sub-menu">
                        <li onClick={() => handleLinkClick("/iqac/feedback/sss", "feedback")}>SSS</li>
                        <li onClick={() => handleLinkClick("/iqac/feedback/student-feedback", "feedback")}> Student’s Feedback</li>
                        <li onClick={() => handleLinkClick("/iqac/feedback/teacher-feedback", "feedbaack")}> Staff's Feedback </li>
                        <li onClick={() => handleLinkClick("/iqac/feedback/employee-feedback", "feed")}> Parent's Feedback </li>
                      </ul>
                    )}
                  </ul>
                </AccordionTab>
                <AccordionTab header="Admission">
                  <ul className="acc-main-menu">
                    <li onClick={() => { handleLinkClick(); window.open("Admission/Prospectus.pdf") }}> Prospectus </li>
                    <li onClick={() => { handleLinkClick(); window.open("Admission/BrochureNICAS.pdf") }}> Brochure </li>
                    <li onClick={() => handleLinkClick("/Admission/Admission_Committee")}> Admission Committee</li>
                    <li onClick={() => handleLinkClick("/Admission/Application_For_Admission")}> Application For Admission </li>
                  </ul>
                </AccordionTab>
                <AccordionTab header="Alumini">
                  <ul className="acc-main-menu">
                    <li onClick={() => handleLinkClick("/alumini/objectives")}> Objectives </li>
                    <li onClick={() => handleLinkClick("/alumini/executive-committee")}> Executive Committee </li>
                    <li onClick={() => handleLinkClick("/alumini/news-letter")}> Newsletter </li>
                    <li onClick={() => handleLinkClick("/alumini/achievers-gallery")}> Achievers Gallery </li>
                  </ul>
                </AccordionTab>
                <AccordionTab header="Help Desk">
                  <ul className="acc-main-menu">
                    <li onClick={() => handleLinkClick("/Helpdesk/Inquiry-Desk")}> Inquiry Desk</li>
                    <li onClick={() => handleLinkClick("/Helpdesk/Inquiry-Career")}> Inquiry Career</li>
                  </ul>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
